export default {
    state: {
        overview: null,

        viewability: null,
        gender: null,
        newByReturningClients: null,
        simultaneousConnections: null,

        conectionTimeAvg: null,

        abandonment: null,
        comments: null,
        activeAdvertising: null,
        activeAdvertisers: null,
        activeDevices: null,
        activeEstablishments: null,
        connectedUsers: null,

        access: null,
        clients: null,
        impressions: null,
        weekday: null,
        accessHour: null,
        registerType: null,
        deviceType: null,
        interactionData: null,
        rejection: null,
        engagement: null,
        age: null,
        screenTimeAvg: null,
        ageAverage: null,
        topLocals: null,

        mostViewedSites: null,
        mostViewedIps: null,
        mostUsedProtocols: null,
        usedBandwidth: null,

        totalUser: null,

        filters: {
            date: {
                min: "2021-01-01",
                max: "2021-01-05"
            },
            advertising: [],
            users: [],
            establishments: [],
            local: [],
            networks: []
        },

        heatMap: null,
    },

    mutations: {
        STATISTICS_SET_ACCESS(state, data) {
            state.access = data;
        },

        STATISTICS_SET_CLIENTS(state, data) {
            state.clients = data;
        },

        STATISTICS_SET_IMPRESSIONS(state, data) {
            state.impressions = data;
        },

        STATISTICS_SET_WEEKDAY(state, data) {
            state.weekday = data;
        },

        STATISTICS_SET_ACCESS_HOUR(state, data) {
            state.accessHour = data;
        },

        STATISTICS_SET_GENDER(state, data) {
            state.gender = data;
        },

        STATISTICS_SET_REGISTER_TYPE(state, data) {
            state.registerType = data;
        },

        STATISTICS_SET_DEVICE_TYPE(state, data) {
            state.deviceType = data;
        },

        STATISTICS_SET_INTERACTION_DATA(state, data) {
            state.interactionData = data;
        },

        STATISTICS_SET_ENGAGEMENT(state, data) {
            state.engagement = data;
        },

        STATISTICS_SET_REJECTION(state, data) {
            state.rejection = data;
        },

        STATISTICS_SET_AGE(state, data) {
            state.age = data;
        },

        STATISTICS_SET_SCREEN_TIME_AVG(state, data) {
            state.screenTimeAvg = data;
        },

        STATISTICS_SET_AGE_AVG(state, data) {
            state.ageAverage = data;
        },

        //-------------------------------------------------//

        STATISTICS_SET_OVERVIEW(state, data) {
            state.overview = data;
        },

        STATISTICS_SET_VIEWABILITY(state, data) {
            state.viewability = data;
        },

        STATISTICS_SET_NEW_BY_RETURNING_CLIENTS(state, data) {
            state.newByReturningClients = data;
        },

        STATISTICS_SET_SIMULTANEOUS_CONNECTIONS(state, data) {
            state.simultaneousConnections = data;
        },

        STATISTICS_SET_CONECTION_TIME_AVG(state, data) {
            state.conectionTimeAvg = data;
        },

        STATISTICS_SET_ABANDONMENT(state, data) {
            state.abandonment = data;
        },

        STATISTICS_SET_COMMENTS(state, data) {
            state.comments = data;
        },

        STATISTICS_SET_MOST_VIEWED_SITES(state, data) {
            state.mostViewedSites = data;
        },

        STATISTICS_SET_MOST_VIEWED_IPS(state, data) {
            state.mostViewedIps = data;
        },

        STATISTICS_SET_MOST_USED_PROTOCOLS(state, data) {
            state.mostUsedProtocols = data;
        },

        STATISTICS_SET_USED_BANDWIDTH(state, data) {
            state.usedBandwidth = data;
        },

        STATISTICS_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value
            };
        },

        STATISTICS_RESET_FILTERS(state) {
            state.filters = {
                date: {
                    min: null,
                    max: null
                },
                advertising: [],
                users: [],
                establishments: [],
                local: []
            };
        },

        STATISTICS_SET_ACTIVE_ADVERTISING(state, data) {
            state.activeAdvertising = data;
        },

        STATISTICS_SET_ACTIVE_ADVERTISERS(state, data) {
            state.activeAdvertisers = data;
        },

        STATISTICS_SET_ACTIVE_ESTABLISHMENTS(state, data) {
            state.activeEstablishments = data;
        },

        STATISTICS_SET_ACTIVE_DEVICES(state, data) {
            state.activeDevices = data;
        },

        STATISTICS_SET_CONNECTED_USERS(state, data) {
            state.connectedUsers = data;
        },

        STATISTICS_SET_TOTAL_USER(state, data) {
            state.totalUser = data;
        },

        STATISTICS_SET_HEAT_MAP(state, data) {
            state.heatMap = data;
        },

        STATISTICS_SET_TOP_LOCALS(state, data) {
            state.topLocals = data;
        }
    }
};
